
import { Vue, Component, Prop } from "vue-property-decorator";

enum TabFontSize {
  SMALL = "small",
  BIG = "big",
}

@Component
export default class TabsUnderline extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly options!: string[];
  @Prop({ type: Number, default: 0 }) readonly selectedIndex!: number;
  @Prop({ type: Array, default: () => [] }) readonly routes!: string[];
  @Prop({ type: String, default: "" }) readonly navClass!: string;
  @Prop({ type: String, default: "" }) readonly listClass!: string;
  @Prop({ type: String, default: "small" }) readonly tabTitleSize!: TabFontSize;

  currentRoute: string = "";
  isCurrentRoot: boolean = true;

  get isResourcesPage(): boolean {
    const isNewPath = this.$route.params.id !== undefined;
    const contractor = /^\/company_database\/contractors\/[0-9a-f-]+/;
    const managers = /^\/managers\/[0-9a-f-]+/;
    const projects = /^\/clients_visit\/[0-9a-f-]+/;
    const contarctorProjects = /^\/clients\/[0-9a-f-]+/;

    return (
      isNewPath &&
      (contractor.test(this.$route.path) ||
        managers.test(this.$route.path) ||
        projects.test(this.$route.path) ||
        contarctorProjects.test(this.$route.path))
    );
  }

  get isJobPosting(): boolean {
    return (
      this.$route.path.includes("postings") &&
      !this.$route.path.includes("jobboard")
    );
  }
  get isjobBoard(): boolean {
    return this.$route.path.includes("jobboard/postings");
  }
  get isMarketPlacePage(): boolean {
    return this.$route.path.includes("/profile/settings");
  }

  tabStyle(i: number): object {
    const applySize = this.tabTitleSize == TabFontSize.BIG;
    const isSelectedIndex = this.selectedIndex === i;

    return {
      "text-base": applySize,
      "border-secondary-black focus:border-secondary-black-600":
        isSelectedIndex,
      "text-gray-new focus:text-gray-700 focus:border-gray-300 hover:border-b-2 hover:border-secondary-black focus:border-secondary-black focus:border-b-2 hover:text-gray-700 hover:border-gray-300":
        !isSelectedIndex,
      "ml-4 sm:ml-8": i > 0,
    };
  }

  created() {
    this.setCurrentRoute();
  }

  mounted() {
    this.$watch("$route", this.setCurrentRoute);
  }

  setCurrentRoute() {
    this.currentRoute = this.$route.name;
    if (this.currentRoute === "talent_mapping") {
      this.isCurrentRoot = false;
    } else {
      this.isCurrentRoot = true;
    }
  }

  get listStyles(): Object {
    return {
      "pt-5 pb-3.5": true,
      "mr-2.5": !this.isMarketPlacePage && !this.isJobPosting,
      "px-7 border-b border-gray-200":
        this.isResourcesPage || this.isMarketPlacePage || this.isJobPosting,
      "": !this.isResourcesPage,
    };
  }
}
